/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import {AuthActions} from '../../actions/auth';
import {currentUserSelector} from '../../reducers/users';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import logo from '../../static/img/planz-logo-white.svg';
import '../../styles/Login.css';

class Login extends Component {
  static propTypes = {
    user: PropTypes.object,
    authenticate: PropTypes.func.isRequired,
    login: PropTypes.func,
    logout: PropTypes.func,
    intl: PropTypes.object,
  }

  state = {
    username: '',
    password: ''
  }


  handleChange = (event) => {
    const {name, value} = event.target;
    this.setState({
      ...this.state,
      [name]: value
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    const {username, password} = this.state;
    this.props.authenticate(username, password);
  }

  inputElement = (type, name, placeholder) => (
      <div className="form-group">
        <input
            name={name}
            type={type}
            placeholder={placeholder}
            className="form-control"
            value={this.state[name]}
            onChange={this.handleChange}
        />
      </div>
  )

  render() {
    const {error} = this.props;

    const err = (error) ? <div className="alert alert-danger" role="alert" data-test="error">{error}</div> : '';

    return (
        <div className="wrapper">
          <div className="login">
            <img src={logo} className="loginLogo" width={300} alt="Sight Logo"/>
            <form className="login-form" onSubmit={::this.handleSubmit}>
              {this.inputElement('email', 'username', 'Email')}
              {this.inputElement('password', 'password', 'Password')}
              {err}
              <button type="submit" className="btn btn-primary loginBtn" onClick={::this.handleSubmit}>
                Login
              </button>

              <div className="form-group pull-right">
                <small className="forgot-pw">
                  Forgot password？<Link style={{color: '#5e97be'}} to="/forgot/password">Click Here</Link>
                </small>
              </div>
              <div style={{color: '#fff', fontSize: 14, marginTop: 50, textAlign: 'center'}}>
                Not Registered? <Link to="/freetrial/signup" style={{color: '#5e97be'}}>Click here to create an account.</Link>
              </div>
            </form>
          </div>
        </div>
    );
  }
}

const errorSelector = (state) => state.auth.get('error');

const LoginContainerSelector = immutableCreatorSelector(
    [errorSelector, currentUserSelector],
    (error, user) => ({
      error,
      user,
    })
);

@connect(LoginContainerSelector)
export default class LoginContainer extends Component {
  static propTypes = {
    user: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
  }

  render() {
    const {user, error, dispatch} = this.props;

    return (<Login user={user} error={error} dispatch={dispatch} {...bindActionCreators(AuthActions, dispatch)}>
      {this.props.children}
    </Login>);
  }
}



// WEBPACK FOOTER //
// ./src/views/public/Login.js